import AutoAwesomeMosaicOutlinedIcon from '@mui/icons-material/AutoAwesomeMosaicOutlined';
import { _ } from '/@/locale';
import CreateGrowerSection from '/@/views/dashboard/rv/components/create-grower-section';
import { EMPTY_SECTION_SX } from './constants';

export function MyFieldsEmptyState({ onAddFields, onAddField }: { onAddFields: () => void; onAddField: () => void }) {
    return (
        <CreateGrowerSection
            onAddFields={onAddFields}
            onButtonClick={onAddField}
            title={_('Agregá lotes para generar recomendaciones')}
            subtitle={_('Vas a poder generar recomendaciones personalizadas según las condiciones del lote.')}
            buttonLabel={_('Agregar lote')}
            icon={<AutoAwesomeMosaicOutlinedIcon sx={{ width: 36, height: 36, mb: 1 }} color='primary' />}
            sx={EMPTY_SECTION_SX}
        />
    );
}

export function NoGrowersEmptyState({
    onAddFields,
    onOpenGrowersModal,
}: {
    onAddFields: () => void;
    onOpenGrowersModal: () => void;
}) {
    return (
        <CreateGrowerSection
            onAddFields={onAddFields}
            onOpenModal={onOpenGrowersModal}
            title={_('Agregá un productor para empezar a recomendar')}
            subtitle={_('Vas a poder generar recomendaciones personalizadas para sus lotes.')}
            sx={EMPTY_SECTION_SX}
            singleGrower
        />
    );
}

export function GrowerHasNoFieldsEmptyState({
    onAddFields,
    onAddField,
}: {
    onAddFields: () => void;
    onAddField: () => void;
}) {
    return (
        <CreateGrowerSection
            onAddFields={onAddFields}
            onButtonClick={onAddField}
            title={_('Este productor aún no tiene lotes agregados')}
            subtitle={_('Cuando se carguen, vas a poder hacer el seguimiento desde esta pantalla.')}
            buttonLabel={_('Agregar lote')}
            icon={<AutoAwesomeMosaicOutlinedIcon sx={{ width: 36, height: 36, mb: 1 }} color='primary' />}
            sx={{ ...EMPTY_SECTION_SX, width: '100%' }}
        />
    );
}
